import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { TracksGpsState } from './types';

export default function initialState(): TracksGpsState {
  return {
    ...initialStateSubscribable(),
  };
}
